@if (!magicCard) {
    <loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
}
@else {
    <div class="justify-center items-center md:items-start flex flex-col md:flex-row gap-4">
        <!-- Left Column -->
        <div class="flex flex-col items-center justify-center w-[340px] gap-4">
            <!-- MTG Cards have a 5:7 Aspect Ratio -->
            <div class="flex flex-col w-[340px] min-h-[476px] card-shadow mtg-card-rounded card-background">
                <img class="w-[340px] h-[476px] mtg-card-rounded" [attr.src]="cardImageUrl"/>
                @if (isAuthed) {
                    <item-collection-count
                        [game]="magicCard!.game!" 
                        [itemType]="magicCard!.itemType!"
                        [itemId]="magicCard!.id!"
                        [hasNormalVersion]="magicCard!.treatment.normal"
                        [hasSpecialVersion]="magicCard!.treatment.special"
                        [count]="getCollectedNormalCount()"
                        [specialCount]="getCollectedSpecialCount()"
                        [proxyCount]="getCollectedProxyCount()"
                        class="flex flex-row text-slate-200 text pt-1 pb-1 pl-2 pr-2 gap-5 align-middle">
                    </item-collection-count>
                }
            </div>
            @if (canFlip()) {
                <button (click)="flipFace()" class="flex flex-row items-center justify-center gap-4 bg-slate-100 w-[140px] shadow border border-ponder-light text-ponder-light p-1 rounded">
                    <svg class="w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="flipIconSvg" />
                    </svg>
                    Flip
                </button>
            }
        </div>
        <!-- Middle Column -->
        <div class="flex flex-col w-[340px] gap-4">
            <magic-card-text [magicCard]="magicCard!"></magic-card-text>
            @if (isLocalized()) {
                <magic-card-text [magicCard]="magicCard!" [isTranslation]="isLocalized()"></magic-card-text>
            }
            <magic-card-details [username]="username" [collectedMagicCard]="collectedMagicCard!"></magic-card-details>
        </div>
        <!-- Right Column -->
        <div class="flex flex-col w-[340px] gap-4">
            <magic-card-versions [magicCard]="magicCard!" [currIndex]="reprintCurrIndex" [reprints]="reprints"></magic-card-versions>
            @if (isAuthed) {
                <magic-card-in-decks [username]="username!" [magicCard]="magicCard!"></magic-card-in-decks>
                <magic-card-admin [magicCard]="magicCard!"></magic-card-admin>
            }
        </div>
    </div>
}